import { CalculateDistanceOutput, RouteDistances } from 'graphql.generated';

// Helper function to calculate dock_start_end_dock
export function calculateDockToDockDistance(distances: RouteDistances): CalculateDistanceOutput {
  if (!distances?.dock_start || !distances?.start_end || !distances?.end_dock) return undefined;

  const { dock_start, start_end, end_dock } = distances;

  return {
    averageTime: (dock_start.averageTime || 0) + (start_end.averageTime || 0) + (end_dock.averageTime || 0),
    distanceUnits: dock_start.distanceUnits || start_end.distanceUnits || end_dock.distanceUnits,
    estimatedTime: (dock_start.estimatedTime || 0) + (start_end.estimatedTime || 0) + (end_dock.estimatedTime || 0),
    totalDistance: (dock_start.totalDistance || 0) + (start_end.totalDistance || 0) + (end_dock.totalDistance || 0),
    flagTrip: dock_start.flagTrip || start_end.flagTrip || end_dock.flagTrip,
    distances: [
      ...(dock_start.distances || []),
      ...(start_end.distances || []),
      ...(end_dock.distances || []),
    ],
  };
}
